import {Component, OnInit} from '@angular/core';
import {Router}  from '@angular/router';
import {CognitoAuthService} from '../../shared/auth/cognito.service';
import {Globals} from '../../shared/globals/globals';
import {LocalService}  from '../../shared';
import {IsoService} from '../../shared';

declare const $;

@Component({
    selector: 'user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.css'],
    providers: [CognitoAuthService]
})
export class UserProfileComponent implements OnInit {

    private Globals;
    private currentPassword;
    private newPassword;
    private confirmPassword;
    private passwordUpdated: boolean;
    private passwordFailed: boolean;

    private emailAlerts = true;
    private emailEvents = false;
    private emailInsight = false;
    private mobileAlerts = true;
    private mobileEvents = false;
    private mobileInsight = true;
    private syslogAlerts = true;
    private syslogEvents = true;
    private syslogInsight = true;
    private passwordConditions = {
        length: {
            regex: /^.{8,20}$/,
            satisfied: false
        },
        lowercase: {
            regex: /[a-z]+/,
            satisfied: false
        },
        uppercase: {
            regex: /[A-Z]+/,
            satisfied: false
        },
        number: {
            regex: /[0-9]+/,
            satisfied: false
        },
        noSpace: {
            regex: /^\S+$/,
            satisfied: false
        }
    };

    iso: any = {};
    creatingISO: boolean;

    constructor(private router: Router, public authService: CognitoAuthService, private local: LocalService, private isoService: IsoService) {
        this.Globals = Globals;
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.passwordUpdated = false;
        this.passwordFailed = false;
        this.creatingISO = false;
    }

    ngOnInit() {
        this.getIsoLocation();
    }

    changeNotifyAlerts(e) {
        console.log('Notify Alerts changed: ' + this.emailAlerts.toString());

        // Submit change to
    }
    changeNotifyEvents(e) {
        console.log('Notify Events changed: ' + this.emailEvents.toString());
    }

    updateUserProfile() {
        const self = this;

        // console.log('oldpassword: ", this.currentPassword);
        // console.log("newPassword: ", this.newPassword);

        this.authService.changePassword(this.currentPassword, this.newPassword, {
            cognitoCallback: function (message, result) {
                if (result) {

                    console.log('Password updated');

                    self.passwordUpdated = true;
                    self.passwordFailed = false;
                } else {

                    console.log('Error: ', message);

                    self.passwordFailed = true;
                    self.passwordUpdated = false;
                }
            }
        });
    }

    cancelChanges() {
        this.router.navigate(['']);
    }

    checkPasswordConditions() {

        const self = this;
        Object.keys(self.passwordConditions).forEach(function (key) {
            self.passwordConditions[key].satisfied = self.passwordConditions[key].regex.test(self.newPassword);
            // console.log('key = ', key, ' = ', self.passwordConditions[key].satisfied);
        });
    }

    setTheme(i) {

        this.local.setTheme(i);

        /*
         // console.log('jQuery = ', $);
         let oldTheme = this.Globals.theme;
         let newTheme = this.Globals.themes[i];
         let $stylesheet = $('#theme-stylesheet');
         let path = $stylesheet.attr('href').replace(new RegExp(oldTheme, 'g'), newTheme);

         console.log(path);

         $stylesheet.attr('href', path);
         this.Globals.theme = this.Globals.themes[i];
         */
    }

    // This is the main function invoked to retrieve the customer information
    getIsoLocation() {

        console.log('getIsoLocation in customer-info');

        const self = this;

        self.isoService.getIsoLocation({}).subscribe(function (iso) {

            self.iso['Location'] = iso.Location;
            self.iso["Username"] = iso.Username;
            self.iso["Password"] = iso.Password;

        }, function (err) {
            console.log('Error in getting customer data. Called from customer-info.component.ts');
            console.log(err);
        });
    }

    // When you click on Create ISO
    createIsoClick(evt) {
        console.debug(evt.type);

        const self = this;

        self.creatingISO = true;

        self.isoService.createIso({}).subscribe(function(iso) {
            self.iso = iso;
        }, function (err) {
            console.error('Error in creating customer ISO. Called from customer-info.component.ts');
            console.log(err);
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/containers/user-profile/user-profile.component.ts